export default {
  'general.next': 'Next',
  'general.hi': 'Hi',
  'general.start': 'Start',
  'general.cancel': 'Cancel',
  'general.send': 'Send',
  'general.yes': 'Yes',
  'general.no': 'No',
  'general.ok': 'OK',
  'general.register': 'Register',
  'general.thankYou': 'Thank you!',
  'general.tryAgain': 'Try Again',
  'general.accessWithoutAccount': 'Access Without Account',
  'general.alert': 'Alert',
  'general.confirm': 'Confirm',
  'general.title.billing': 'Billing',
  'general.title.dashboard': 'Dashboard',
  'general.title.forgotPassword': 'Forgot Password',
  'general.title.setNewPassword': 'Set Your Password',
  'general.title.patientDocuments': 'Patient Documents',
  'general.title.verifyIdentity': 'Verify Identity',
  'general.successRequest': 'Successful request!',
  'home.title': 'Home',
  'signIn.forgotPassword': 'Forgot Password?',
  'signIn.dontHaveAccount': 'Existing Patient Account Creation?',
  'signIn.button.signIn': 'Sign In',
  'signIn.register': 'Register here',
  'signIn.placeholder.email': 'Email',
  'signIn.placeholder.password': 'Password',
  'signIn.placeholder.confirmPassword': 'Confirm Password',
  'signIn.setYourPassword': 'Set Your Password',
  'signIn.currentPassword': 'Current Password',
  'signIn.newPassword': 'New Password',
  'signIn.confirmNewPassword': 'Confirm New Password',
  'signIn.setPassword': 'Set Password',
  'signIn.otp.title': 'Two Factor Authentication',
  'signIn.forgotPassword.description':
    'Enter your email address and we will send a new password to your mail box. Please check your mail to change your password.',
  'signIn.otp.placeHolder': '6-digit code',
  'signIn.otp.whatIsIt': 'What’s this?',
  'signIn.otp.button.verify': 'Verify',
  'signIn.otp.resend.descriptionSMS':
    'We just sent you a message via SMS with your authentication code.  Enter the code in the form above to verify your identity.',
  'signIn.otp.resend.descriptionEmail':
    'We just sent you an email with your authentication code. Enter the code in the form above to verify your identity.',
  'signIn.otp.resentOTP': 'Re-send the code',
  'signIn.otp.authenCodeRequired': 'Please enter authentication code.',
  'signIn.otp.format': 'Please enter a valid authentication code.',
  'signIn.selectMethod': 'Select Patient Verification Method',
  'signIn.smsChoice': 'SMS ending in %{phoneNumber}',
  'signIn.emailChoice': 'Email %{email}',
  'signIn.label.email': 'Email',
  'signIn.label.password': 'Password',
  'signIn.error.format.email': 'Please enter a valid Email Address.',
  'signIn.error.required.email': 'Email Address cannot be blank.',
  'signIn.error.required.password': 'Password cannot be blank.',
  'register.title': 'Please Provide Patient Information',
  'register.label.activationCode': 'Activation Code',
  'register.label.dob': 'Date of Birth',
  'register.label.zipCode': 'ZIP Code',
  'register.label.email': 'Email Address',
  'register.label.phoneNumber': 'Phone Number',
  'register.description.activationCode':
    'Enter your activation code as it appears in your enrollment email. You will not need this code after you complete the sign up process.',
  'register.notHaveActiveCode': 'Don’t have an activation code?',
  'register.requestActiveCode': 'Request an Activation Code',
  'register.successful.title': 'Registration Successful 👍',
  'register.successful.description':
    'Please check your email (and possibly your spam folder) for next steps.',
  'register.successful.buttonBack': 'Back to Sign In',
  'register.label.lastName': 'Last Name',
  'register.button.request': 'Request',
  'register.error.required.lastName': 'Last Name cannot be blank.',
  'register.error.required.dob': 'Date of Birth cannot be blank.',
  'register.error.required.email': 'Email address cannot be blank.',
  'register.error.format.dob':
    'Please enter a valid Date of Birth in the format of MM/DD/YYYY.',
  'register.error.format.email': 'Please enter a valid email address.',
  'register.error.maxDate.dob': 'Date of Birth cannot be in the future.',
  'navbar.menu.title': 'Family Members',
  'navbar.menu.button.reset': 'Reset Password',
  'navbar.menu.button.signOut': 'Sign Out',
  'dashboard.title.upcomingAppointment': 'Upcoming Appointments',
  'dashboard.title.requestAppointment': 'Request an Appointment',
  'dashboard.appointment.table.reason': 'Reason for Visit',
  'dashboard.appointment.table.appointment': 'Date and Time',
  'dashboard.appointment.table.provider': 'Provider',
  'dashboard.appointment.table.patient': 'Patient',
  'dashboard.appointment.table.balance': 'Balance',
  'dashboard.appointment.table.quantity': 'Quantity',
  'dashboard.appointment.form.appointmentType': 'Appointment Type',
  'dashboard.appointment.form.provider': 'Provider',
  'dashboard.appointment.button.billing': 'Pay Now',
  'dashboard.appointment.button.document': 'Manage Documents',
  'dashboard.userBalance.balanceMessage': 'You have a balance of %{total} due',
  'dashboard.userBalance.total': 'Total',
  'dashboard.userBalance.noBilling': 'There is no billing.',
  'patientDocument.title': 'Patient Forms',
  'patientDocument.description.complete':
    'Please complete our patient forms in order to make your check-in process quick and easy.',
  'patientDocument.description.question': `Our questionnaire consists of %{amount} documents. To complete a document, simply enter and submit the requested information. While most fields are optional, some may be required and are marked with an asterisk (*). Please do not use your browser's back or forward buttons, as they may undo or redo your recent actions and result in errors.`,
  'patientDocument.description.info':
    'The information you submit is encrypted for your protection and will be transmitted securely to our office.',
  'patientDocument.description.callAt':
    'If you have questions at any time, please call our office at',
  'patientDocument.description.mailAt': 'or send us an email at',
  'patientDocument.sendMessages.cancelPopup.title': 'Are you sure?',
  'patientDocument.sendMessages.cancelPopup.description':
    'Do you want to go back without saving?',
  'patientDocument.editSubmission': 'Edit Submission',
  'patientDocument.complete': 'Complete',
  'patientDocument.guestForm': `Guest's Forms`,
  'patientDocument.dialog.from': 'From',
  'patientDocument.dialog.title': 'Send message to your dental',
  'patientDocument.dialog.yourName': 'Your Name',
  'patientDocument.dialog.to': 'To',
  'patientDocument.dialog.placeholderTo': 'kihalo@wuvuthun.org',
  'patientDocument.dialog.subject': 'Subject',
  'patientDocument.dialog.placeholderSubject': 'Default',
  'patientDocument.dialog.messageBody': 'Message Body',
  'patientDocument.confirmUsingLatestUserInfo.title':
    'Your information has been updated!',
  'patientDocument.confirmUsingLatestUserInfo.detail':
    'Do you want to use the new updated data for the form?',
  'resetPassword.title': 'Reset Password',
  'resetPassword.successful.title': 'Successful password reset!',
  'resetPassword.successful.buttonBack': 'Back to Dashboard',
  'resetPassword.error.format.password':
    'Password must have a minimum of 8 characters with at least 1 upper case, 1 numeric, and 1 special character.',
  'resetPassword.error.format.confirmPassword':
    'The passwords entered do not match.',
  'resetPassword.error.required.password': 'Current Password cannot be blank.',
  'resetPassword.error.required.newPassword': 'New Password cannot be blank.',
  'setPassword.error.format.password':
    'Password must have a minimum of 8 characters with at least 1 upper case, 1 numeric, and 1 special character.',
  'setPassword.error.format.confirmPassword': 'Passwords do not match.',
  'setPassword.error.required.password': 'Password cannot be blank.',
  'setPassword.error.required.confirmPassword':
    'Confirm New Password cannot be blank.',
  'setPassword.successful.title': 'Successful password setting!',
  'setPassword.successful.description':
    'You can now use your new password to sign in to your account!',
  'setPassword.successful.buttonBack': 'Back to Sign In',
  'setPassword.successful.backToDashboard': 'Back to Dashboard',
  'setPassword.title.linkExpired': 'This link has expired',
  'setPassword.description.linkExpired':
    'This link has expired. Please go to Forgot Password on Sign In screen to auto-generate a new link.',
  'forgotPassword.successful.title': 'Successful password setting!',
  'forgotPassword.successful.buttonBack': 'Back to Sign In',
  'formSubmission.buttonBack': 'Back to all Patient Forms',
  'upcomingAppointment.noData': 'There are no scheduled appointments.',
  'billing.error': 'An error occurs when loading billing.',
  'documentAttentions.error': `An error occurs when loading  patient's document.`,
  'upcomingAppointment.error':
    'An error occurs when loading upcoming document.',
  'sendEmail.error': 'Send Failed! Please Try Again!',
  documentAttentions: {
    zero: '0 Document requires your attention',
    one: '1 Document requires your attention',
    other: '%{count} Documents require your attention'
  }
};
